/** Route keys that render the page but may show in-page upgrade (companyUser supplies). */
export const SOFT_UPGRADE_GATED_PKG_ACCESS = Object.freeze([
  "SUPPLIES",
  "MANAGE_SUPPLIES",
  "ARCHIVE_SUPPLIES",
  "SUPPLY_SETTINGS",
]);

/** After cancel (`billingAccessRestricted`), companyUser may only use these paths. */
export const BILLING_RESTRICTED_ALLOWED_PATHS = Object.freeze([
  "/account/profile",
  "/account/upgrade",
  "/account/companySubscription",
  "/account/settings",
  "/account/settings/privacy-data-settings",
]);

/** Restricted company manager (no team admin seat) billing paths. */
export const RESTRICTED_COMPANY_MANAGER_BILLING_PATHS = Object.freeze([
  "/account/companySubscription",
  "/account/upgrade",
]);

export const ACCESS_REASON = Object.freeze({
  LOADING: "loading",
  SUPERUSER: "superuser",
  NO_PKG_KEY: "no_pkg_key",
  SOFT_GATE: "soft_gate",
  PLAN_ROUTE: "plan_route",
  PLAN_DENIED: "plan_denied",
  SUBSCRIPTION: "subscription",
  BILLING_RESTRICTED: "billing_restricted",
});
